import React, { useEffect } from 'react';
import Navigation from './Navigation';
import PeopleSection from './PeopleSection';
import Footer from './Footer';
import PageSEO from './PageSEO';

const PeoplePage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <PageSEO path="/people" />
      <Navigation />
      <main style={{ paddingTop: '60px' }}>
        <PeopleSection />
      </main>
      <Footer />
    </>
  );
};

export default PeoplePage;
